<template>
  <div class="card mt-4">
    <div class="card-header">

      <!--      <svg v-if="isApproved"-->
      <!--           style="width: 30px;float: left;margin-right: 10px;color: green;animation: tada 1.5s ease infinite;"-->
      <!--           xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">-->
      <!--        <path fill-rule="evenodd"-->
      <!--              d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"-->
      <!--              clip-rule="evenodd"/>-->
      <!--      </svg>-->
      <h5 style="line-height: 30px;">
        {{ title }}
        <!--        <svg-->
        <!--            v-b-popover.hover.top="help"-->
        <!--            style="width: 20px;cursor: help"-->
        <!--            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"-->
        <!--            fill="currentColor" class="h-5 w-5">-->
        <!--          <path fill-rule="evenodd"-->
        <!--                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"-->
        <!--                clip-rule="evenodd"></path>-->
        <!--        </svg>-->
      </h5>
      <p>{{ help }}</p>
    </div>
    <div class="card-body">
      <div class="row text-center">
        <div class="col-lg-12">
          <div class="media-body text-right switch-sm float-right" v-if="role.content == 'mentor'">
            Approved
            <label class="switch">
              <input type="checkbox" v-model="isApproved" @change="setApproveStatus"><span class="switch-state"></span>
            </label>
          </div>
          <textarea-autosize
              style="border-radius: 10px;padding: 20px"
              class="form-control"
              :placeholder="placeholder"
              ref="myTextarea"
              v-model="answer"
              @input="update"
              :min-height="150"
              :max-height="250"
              :disabled="isApproved || role.content != 'editor'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'ProjectTextArea',
  props: {
    section: {
      type: Object,
      default: function () {
        return {}
      }
    },
    project: {
      type: Object,
      default: function () {
        return {}
      }
    },
    role: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      answer: '',
      originalId: 0,
      isApproved: false,
      comment: '',
      comments: [],
    }
  },
  created() {
    this.answer = this.section.name
  },
  methods: {

    applyAnswer() {

      let selected = this.project.sections.find((item) => {
        return item.original_id == this.section.id
      })

      this.originalId = selected.id
      this.answer = selected.name
    },
    update: _.debounce(function () {

      this.$emit('updateSection', {
        id: this.section.id,
        answer: this.answer
      })
    }, 1000),
  },
  computed: {
    locale: function () {
      return this.$i18n.locale
    },
    title: function () {
      return this.section.original.translation[this.locale] ? this.section.original.translation[this.locale].name : this.section.original.translation['en'].name
    },
    placeholder: function () {
      return this.section.original.translation[this.locale] ? this.section.original.translation[this.locale].placeholder : this.section.original.translation['en'].placeholder
    },
    help: function () {
      return this.section.original.translation[this.locale] ? this.section.original.translation[this.locale].help : this.section.original.translation['en'].help
    }
  }
};
</script>
